var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"EZahCRF7ygVXMQzJSG0_V"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { 
  init as SentryInit,
  Replay as SentryReplay,
  BrowserTracing as SentryBrowserTracing
} from '@sentry/nextjs';
import config from './config/index';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

SentryInit({
  dsn: SENTRY_DSN || 'https://0bf0818bc86a4c758a907ae0f9aa8290@o185340.ingest.sentry.io/5798807',
  environment: config.env,
  maxBreadcrumbs: 20,
  integrations: [new SentryBrowserTracing({tracePropagationTargets: [config.EnvConfig.graphql.url]}),
    new SentryReplay({maskAllText: false, 
      maskAllInputs: true,
      blockAllMedia: false
    })],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.3,
  replayOnErrorSampleRate: 1.0,
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so 
  // that it will also get attached to your source maps
});
